import { render, staticRenderFns } from "./ques-signature.vue?vue&type=template&id=c5908018&scoped=true"
import script from "./ques-signature.vue?vue&type=script&lang=js"
export * from "./ques-signature.vue?vue&type=script&lang=js"
import style0 from "./ques-signature.vue?vue&type=style&index=0&id=c5908018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5908018",
  null
  
)

export default component.exports